import { Component, OnInit } from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";
import { AuthenticationService } from "../services/authentication.service";
import { Router } from "@angular/router";
import {appConstants} from '../constants/appConstants';

@Component({
  selector: "app-main-nav",
  templateUrl: "./main-nav.component.html",
  styleUrls: ["./main-nav.component.scss"],
})
export class MainNavComponent implements OnInit {
  islogin: boolean = false;
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  constructor(
    private breakpointObserver: BreakpointObserver,
    private _authService: AuthenticationService,
    private _router: Router,
  ) {
    this.islogin = this._authService.isLoggedIn();
  }

  parseHashAccessToken (frag:string)  {
    let splitHast = frag.split('&')
    let accessTokenString = splitHast[1];
    let accessToken = accessTokenString.replace('access_token=', '');
    localStorage.setItem(appConstants.TOKEN_NAME, accessToken);
    this.islogin = true;
    this._router.navigateByUrl("/");
  }
  
  ngOnInit() {
    if (this._authService.isLoggedIn()) {
      this.islogin = true;
    }
    const frag = window.location.hash;
    if (frag && frag.length > 0){
      this.parseHashAccessToken(frag);
    }
    this._authService.userActivated.subscribe((data: string) => {
      if (data == "false") {
        this.islogin = false;
      }
      if (data == "true") {
        this.islogin = true;
      }
    });
  }
  logout() {
    this._authService.logOut();
  }
}
